<nav class="aud-header d-flex justify-content-between aud-menu-shadow">
    <div class="d-flex flex-direction-row align-items-center">
        <div class="logo">
            <img src="assets/img/logo/logo-white.svg" alt="Audacity">
        </div>
        <h5 class="mb-0 aud-ml-50 page-title">{{ activePage }}</h5>
    </div>

    <div class="d-flex align-items-center">
        @if (this.userModel.profile.profileRole === 'FINAL_USER') {
            <div class="d-flex align-items-center">
                <img src="assets/img/icons/urbis-green-icon.svg"
                     class="aud-pr-10"/>
                <h4 class="aud-pr-10"
                    style="color: #fff; padding-top: 5px; padding-right: 35px !important">{{urbisValue}}  </h4>
            </div>
        }
        <button class="aud-btn stripped aud-mr-15" (click)="notifications.toggle($event)">
            @if (!hasNotifications) {
                <img src="assets/img/icons/bell-icon.svg" alt="notificações">
            }
            @if (hasNotifications) {
                <img src="assets/img/icons/bell-notification-icon.svg" alt="notificações">
            }
        </button>
        <button class="aud-btn stripped aud-mr-15 d-flex align-items-center" (click)="user.toggle($event)">
            <h6 class="aud-pr-10" style="color: #fff; padding-top: 5px">{{this.userModel.nameFull}}  </h6>
            <img class="aud-mr-10 user-picture" src="assets/img/icons/account-icon.svg" alt="Utilizador">
            <img src="assets/img/icons/arrow-icon.svg">
        </button>
    </div>
</nav>
<nav class="aud-sub-menu">
    <ul>
        @for (subMenuItem of menus; track subMenuItem) {
            <li>
                <a [routerLink]="subMenuItem.url" [routerLinkActive]="['active']"
                   (click)="setActivePage(subMenuItem.label)">
                    @if (subMenuItem.icon) {
                        <img [src]="subMenuItem.icon"
                             class="aud-pr-10"/>
                    }
                    {{ subMenuItem.label | translate }}
                </a>
            </li>
        }
        <li>
            <a href="{{urlBE}}oauth/start/{{userToken}}">
                <img  src="assets/img/icons/devices-icon.svg"
                      class="aud-pr-10"/>
                Consumos
            </a>
        </li>
    </ul>
</nav>
<!-- O `p-overlayPanel` foi removido no primeng 20; o substituto e o `p-popover`,
     que existe desde o 18 e resolve o conteudo por `ContentChild('content')` --
     um `pTemplate` sem nome deixaria de casar e o popover abriria vazio. -->
<p-popover #notifications [appendTo]="'body'">
    <ng-template #content>
        <div class="aud-popover-menu">
            @for (notification of notificationData; track notification) {
                <p class="aud-popover-title notif" (click)="showNotification(notification)">
                    <span>{{ notification.notification.message }}</span>
                </p>
            }
        </div>
    </ng-template>
</p-popover>

<p-popover #user [appendTo]="'body'">
    <ng-template #content>
        <div class="aud-popover-menu">
            <ul>
                <li>
                    <a routerLink="#" [routerLink]="profileRoutingNames.ROUTE_PROFILE">Perfil utilizador</a>
                </li>
            </ul>
            <p class="aud-popover-title">Ações</p>
            <ul>
                <li>
                    <a routerLink="#" (click)="logout()">Logout</a>
                </li>
            </ul>

        </div>
    </ng-template>
</p-popover>
<p-dialog [(visible)]="displayMaximizable" [modal]="true"
          [style]="{background: 'white'}"
          [maximizable]="true"
          [draggable]="false">
    <div class="container-fluid aud-content" style="padding-top: 0px;">
        <div class="row justify-content-center">
            <div class="col-12 d-flex justify-content-between">
                <div class="align-items-center">
                    <h2>Notificação</h2>
                    <div class="aud-underline aud-mb-30"></div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="aud-card">
                    <div class="w-100 aud-mr-25">
                        <p class="aud-popover-title">{{textNotification}}</p>
                        <br>
                        <br>
                        <p class="aud-popover-title">{{dateNotification | date: 'dd/MM/yyyy'}}</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</p-dialog>
